export default __webpack_public_path__ + "static/media/Qe_4.451a3949.JPG";